import * as d3 from 'd3';


const simpleLine = function(args) {
  this.width = 100;//args.width ? args.width : 30;
  this.height = args.height ? args.height : 35;
  this.data = args.data;
  this.hoverDataElem = args.bindHoverDataTo;
  this.margin = 2;
	this.color = args.color;
	this.wrapperelem = args.bindTo;
	this.svg = this.wrapperelem
			.append("svg")
			.attr("viewBox", "0 0 100 35")
			.classed("svg-content", true)


  //ensure data is sorted by date


  this.drawLine(this.data);
  this.dataPointHover(this.data);

};



simpleLine.prototype.drawLine = function(data) {
  const _this = this;

  _this.y = d3.scaleLinear()
    .range([_this.margin, _this.height - _this.margin])
    .domain(d3.extent(data.map(function (d) { return d.value })).reverse())
      .clamp(true);
  

  _this.x = d3
    .scaleOrdinal()
    .range(
      d3.range(data.length).map(function(d, i) {
        return i * Math.round(_this.width / data.length-1) + _this.margin;
      })
    )
    .domain(d3.range(data.length-1));

  _this.linegroup = _this.svg.append("g").attr("class","lineg");


  _this.linepath = d3.line()
    .x(function(d, i) {return _this.x(i);})
    .y(function(d) {return _this.y(d.value);})
     .curve(d3.curveCardinal);

  _this.line = _this.linegroup
    .append("path")
    .datum(data)
    .classed("line", true)
    .attr("stroke-width", 2)
    .attr("stroke", _this.color)
    .attr('fill', 'none')
    .attr("d", _this.linepath);

    // let totalLength = _this.line.node().getTotalLength();
		//
    // _this.line
    //   .attr("stroke-dasharray", totalLength + " " + totalLength)
    //   .attr("stroke-dashoffset", totalLength)
    //   .transition()
    //     .duration(400)
    //     .ease(d3.easeLinear)
    //     .attr("stroke-dashoffset", 0)
};



simpleLine.prototype.dataPointHover = function(data) {
  const _this = this;

   let circlegroups = _this.linegroup.selectAll("g.circle")
  .data(data).enter()
  .append('g').classed('circle', true);
	
	
	let circles = circlegroups.append('circle')
			.attr('r', '8')
			.attr('cx', function (d, i) {
				return _this.x(i)
			})
			.attr('cy', function (d) {
				return _this.y(d.value)
			})
			.datum({'color': _this.color})
			.attr('opacity', 0)
			.attr('fill', function (d) {
				return d.color
			})
	;

}


export default simpleLine;
